const getUpdatedFilterForCategory = (
  categoryKey: string,
  latestValuesFromState: any
) => {
  const newValues = `${categoryKey}:${latestValuesFromState
    .filter((cat) => cat.categoryKey === categoryKey)
    .map((item) => item.filterKey)
    .join(",")}`;
  return newValues;
};

const addFiltersToPageUrl = (
  queryStringToUpdate: string, // bq, q, sort
  filtersToAdd: { filterKey: string; categoryKey: string }[]
): URL => {
  const pageUrl = new URL(window.location.href);

  //scenario: all filters need to be removed
  if (filtersToAdd?.length === 0) {
    pageUrl.searchParams.delete("bq");
    pageUrl.searchParams.delete("missingMileage");
    pageUrl.searchParams.delete("awaitingAppraisal");
    return pageUrl;
  }

  // scenario: add in "missingMileage" , sibling of "bq"
  if (
    filtersToAdd.find(
      (item) =>
        item.categoryKey === "missingMileage" && item.filterKey === "false"
    )
  ) {
    pageUrl.searchParams.set("missingMileage", "false");
  } else {
    pageUrl.searchParams.delete("missingMileage");
  }

  // scenario: add in "awaitingAppraisal" , sibling of "bq"
  if (
    filtersToAdd.find(
      (item) =>
        item.categoryKey === "awaitingAppraisal" && item.filterKey === "false"
    )
  ) {
    pageUrl.searchParams.set("awaitingAppraisal", "false");
  } else {
    pageUrl.searchParams.delete("awaitingAppraisal");
  }

  let newPageUrl = pageUrl;
  const filterToUpdate = pageUrl.searchParams.get(queryStringToUpdate); // all values from bq filter
  const filtersToAddUnderBq = filtersToAdd.filter(
    (item) =>
      item.categoryKey !== "missingMileage" &&
      item.categoryKey !== "awaitingAppraisal"
  );

  // scenario: some filters already exist in the URL and they need updating
  if (filterToUpdate) {
    const distinctCategories = Array.from(
      new Set(filtersToAddUnderBq.map((x) => x.categoryKey))
    );

    const aux = distinctCategories.map((categoryname) => {
      const newFilterValues = getUpdatedFilterForCategory(
        categoryname,
        filtersToAddUnderBq
      );

      return newFilterValues;
    });
    const newBq = aux.join("|");
    newPageUrl.searchParams.set(queryStringToUpdate, newBq);
    return newPageUrl;
  }

  if (filtersToAddUnderBq?.length > 0) {
    pageUrl.searchParams.set(
      queryStringToUpdate,
      `${filtersToAddUnderBq[0].categoryKey}:${filtersToAddUnderBq
        .map((item) => item.filterKey)
        .join(",")}`
    );
  }

  return pageUrl;
};

export default addFiltersToPageUrl;
